import {
  contract,
  initClient,
} from '@timeedit/calendar-integration-api-contract';
import { getAccessToken } from '@timeedit/ui-components';
import { configService } from './config.service';

const createFetchClient = (
  baseUrl: string = configService.CALENDAR_INTEGRATION_SERVICE_URL
) =>
  initClient(contract, {
    baseUrl,
    baseHeaders: {
      Authorization: () => `Bearer ${getAccessToken()}`,
    },
  });

export const calendarClient = createFetchClient(
  configService.CALENDAR_INTEGRATION_SERVICE_URL
);
